import { withTextComponent } from '@updater-local/custom-element-v1';

const DEFAULT_DECIMALS = 2;

// For now, until/if we need others, this only handles US currency.
export default class CurrencyFormatter extends withTextComponent() {
  static observedAttributes = ['value', 'decimals'];
  static reflectedAttributes = [{ name: 'decimals' }, { name: 'value' }];

  updated({ value, decimals }) {
    this.textContent = formatCurrency(parseDecimal(decimals), value);
  }
}

customElements.define('upd-currency-formatter', CurrencyFormatter);

function parseDecimal(decimals) {
  const parsed = parseInt(decimals, 10);
  return isNaN(parsed) ? DEFAULT_DECIMALS : parsed;
}

function formatCurrency(decimals, value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}
